import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-accept-modal',
  templateUrl: './accept-modal.component.html',
  styleUrls: ['./accept-modal.component.scss'],
})
export class AcceptModalComponent {

  @Input() isOpenAccept:boolean = false;
  @Input() title:string = '';
  @Output() result = new EventEmitter<boolean>();

  close(value: boolean) {
    this.isOpenAccept = false;
    this.result.emit(value);
  }

}
